<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <el-button type="primary" icon="el-icon-plus" class="btn-add" @click="dialogFormVisible = true" v-if="permissionCodes.indexOf('015004001') !== -1">添加模板</el-button>
      <input-search :placeholder="searchPlaceholder" @search="search" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="deleteTipInfo" :operationArr="operationArr" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @previewRow="previewRow" @downloadRow="downloadRow" />

    <el-dialog title="新增协议模板" :visible.sync="dialogFormVisible">
      <el-tabs v-model="dialogTabsActiveName" type="card" style="margin-bottom: 20px;">
        <el-tab-pane label="基本信息" name="1">
          <div class="dialogTabsTitle" style="margin-top: 0">协议信息</div>
          <div class="dialogTabsMain">
            <el-button size="small" v-for="item in contractInformationList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>
          </div>
        </el-tab-pane>

        <el-tab-pane label="上传模板" name="5">
          <div style="width: 360px;margin: 10px auto;">
            <div style="display: flex;justify-content: flex-start;">
              <div style="line-height: 30px;margin-right: 10px;vertical-align: middle;">
                <span style="color: #FF0000">*</span>
                <span>协议模板名称</span>
              </div>
              <el-input v-model="uploadData.protocolTemplateName" size="small" placeholder="请输入协议模板名称" style="width: 220px;" />
            </div>
            <el-upload
              class="upload-demo"
              drag
              ref="uploadNotice"
              :action="uploadAction"
              :auto-upload="false"
              :headers="uploadHeaders"
              :data="uploadData"
              :before-upload="beforeUploadContract"
              :on-success="uploadContractSuccess"
              :on-error="uploadContractError"
              :limit="1">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文档拖拽至虚线框内或<em>点击上传</em></div>
              <div class="el-upload__text">文档只支持doc, docx格式</div>
            </el-upload>
            <div style="margin-top: 20px;">
              <el-button type="primary" icon="el-icon-plus" class="btn-add" @click="uploadContractTemplate">保存模板</el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import InputSearch from '../../../components/Input/InputSearch'
import TableMain from '../../../components/Table/TableMain'
import {api} from '../../api/SetFocus'
import {errorHandler} from '../../../utils/errorHandler'
import {nError, nSuccess} from '../../../utils/notice'
import {bus} from '../../../utils/bus'
import Clipboard from 'clipboard'

export default {
  components: {
    TableMain,
    InputSearch,
    Breadcrumb},
  name: 'hatch-template',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '智慧文书',
        name: 'contract-template'
      }, {
        value: '协议模板'
      }],
      addBtnValue: '新建账户',
      searchPlaceholder: '协议模板名称',
      searchKey: '',
      deleteTipInfo: '是否确认删除该模板？',
      tableHead: [{
        prop: 'protocolTemplateName',
        label: '协议模板名称'
      }, {
        prop: 'createTime',
        label: '创建时间'
      }],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      operationArr: ['preview', 'download', 'delete'],
      dialogFormVisible: false,
      dialogTabsActiveName: '1',
      // 协议信息
      contractInformationList: ['${入孵编号}', '${住户名称}', '${主营项目}', '${孵化期限}', '${开始年}', '${开始月}', '${开始日}', '${结束年}', '${结束月}', '${结束日}', '${租赁信息房源信息}'],
      uploadData: {
        protocolTemplateName: '',
      },
      uploadHeaders: {
        token: '',

        'yq-app-code': ''
      },
      uploadAction: api.uploadHatchTemplate
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    this.uploadHeaders.token = bus.global.token
    this.uploadHeaders['yq-app-code'] = bus.global.yqCode
    this.getPage()
  },
  activated() {
    this.getPage()
  },
  methods: {
    getPage () {
      this.$axios.post(api.getHatchTemplatePage, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        searchKey: this.searchKey
      })
        .then(res => {
          if (res.data.retCode === 1) {
            this.total = res.data.data.total
            let data = res.data.data.list
            data.map(v => {
              if (v.createTime) {
                v.createTime = v.createTime.slice(0, 19)
              }
            })
            this.tableData = data
          }
        })
        .catch(errorHandler('获取协议列表失败'))
    },
    changePagination (data) {
      this.pageNum = data[0]
      this.pageSize = data[1]
      this.getPage()
    },
    search (v) {
      this.pageNum = 1
      this.searchKey = v
      this.getPage()
    },
    // 删除
    deleteLine (code) {
      let codeStr = code.join('')
      this.$axios.post(`${api.deleteHatchTemplateByCodes}`, [codeStr])
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.getPage()
          }
        })
        .catch(errorHandler('删除协议失败'))
    },
    // 协议预览
    previewRow (code) {
      this.tableData.map(v => {
        if (v.code === code) {
          window.open('http://view.officeapps.live.com/op/view.aspx?src=' + v.path, '_blank')
        }
      })
    },
    // 协议下载
    downloadRow (code) {
      this.tableData.map(v => {
        if (v.code === code) {
          window.open(v.path, '_blank')
        }
      })
    },
    // 保存协议
    uploadContractTemplate () {
      console.log(123)
      this.$refs.uploadNotice.submit()
    },
    beforeUploadContract () {
      if (!this.uploadData.protocolTemplateName) {
        nError('请输入协议模板名称')
        return false
      }
    },
    // 上传成功
    uploadContractSuccess () {
      this.$refs.uploadNotice.clearFiles()
      this.uploadData.protocolTemplateName = ''
      this.dialogFormVisible = false
      this.dialogTabsActiveName = '1'
      this.getPage()
    },
    // 上传失败
    uploadContractError (err) {
      nError('上传失败')
    },
    download (data) {
      if (!data) {
        return
      }
      let url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', 'excel.xlsx')

      document.body.appendChild(link)
      link.click()
    },
    // 复制按钮内容
    copy() {
      let clipboard = new Clipboard('.copyButton')
      clipboard.on('success', e => {
        nSuccess('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        nError('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy()
      })
    }
  },
  watch: {
    dialogFormVisible(val) {
      if (this.dialogFormVisible === false) {
        this.$refs.uploadNotice.clearFiles()
        this.uploadData.protocolTemplateName = ''
      }
    }
  }
}
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-add {
    border: 0;
    color: #FFF;
    padding: 8px 16px;
    background-color: #00a0e6;
  }
  .btn-add:hover {
    color: #FFF;
    background-color: #06b3ff;
  }
  .dialogTabsTitle {
    text-align: left;
    font-size: 16px;
    margin-top: 10px;
    font-weight: 500;
    color: #333333;
  }
  .dialogTabsMain {
    text-align: left;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .copyButton {
    color: #999999;
    padding: 8px 16px;
    margin: 10px 10px 0 10px;
    background-color: #FFFFFF;
    border: 1px solid #cccccc;
  }
  .copyButton:hover {
    color: #00A0E6;
    border: 1px solid #00A0E6;
  }
  .upload-demo {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/Document/HatchTemplate/HatchTemplate.vue